import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, } from '@/components/ui/dialog';
/**
 * Small confirm step for Settings actions that cannot be undone from the
 * screen they start on (removing a signature, discarding unsaved edits).
 *
 * A real dialog rather than window.confirm: it nests inside the Settings
 * modal as its own Radix layer, so Escape or an outside tap cancels only this
 * step and never closes Settings underneath, and it reads the same on every
 * device (iOS renders window.confirm as a bare system alert).
 */
export function SettingsConfirmDialog({ open, title, description, confirmLabel, cancelLabel, destructive = false, onConfirm, onCancel, }) {
    return (_jsx(Dialog, { open: open, onOpenChange: (next) => !next && onCancel(), children: _jsxs(DialogContent, { className: "max-w-sm", children: [_jsxs(DialogHeader, { children: [_jsx(DialogTitle, { children: title }), _jsx(DialogDescription, { children: description })] }), _jsxs(DialogFooter, { className: "gap-2 sm:space-x-0", children: [_jsx(Button, { variant: "outline", onClick: onCancel, children: cancelLabel }), _jsx(Button, { variant: destructive ? 'destructive' : 'default', 
                            // The dialog stays on screen through its close animation. A second
                            // tap on Confirm in that window (a double tap) must not run the
                            // action again: by then `open` is already false.
                            onClick: () => {
                                if (open)
                                    onConfirm();
                            }, children: confirmLabel })] })] }) }));
}
